export const normalizeInsuranceCard = (card) => {
  if (card.title === 'NHS (UK)') {
    return {
      ...card,
      location: 'United Kingdom'
    }
  }

  return card
}
